// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import Meta from "vue-meta";
import store from "./store";
import VueScrollTo from "vue-scrollto";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import VueSweetAlert2 from "vue-sweetalert2";
import Loading from "vue-loading-overlay";
import { BootstrapVue } from "bootstrap-vue";
import VueAwesomeSwiper from "vue-awesome-swiper";
import VModal from "vue-js-modal";
import vSelect from "vue-select";
import VCalendar from "v-calendar";
import * as Sentry from "@sentry/browser";
import * as Integrations from "@sentry/integrations";
import ToggleButton from "vue-js-toggle-button";
import Toasted from "vue-toasted";

// require styles
import "swiper/dist/css/swiper.css";
import "vue-select/dist/vue-select.css";

library.add(fas);

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("v-select", vSelect);
Vue.use(VueScrollTo);
Vue.use(ToggleButton);
Vue.use(Toasted, { duration: 3000 });
Vue.use(VueSweetAlert2, {
  showCloseButton: true,
  showClass: {
    popup: "" // disable popup animation
  }
});
Vue.use(Loading);
Vue.use(BootstrapVue);
Vue.use(VueAwesomeSwiper /* { default global options } */);
Vue.use(VModal, {
  dynamic: true,
  injectModalsContainer: true
});
Vue.use(require("vue-cookies"));
Vue.use(VCalendar);
Vue.use(Meta);

Vue.config.productionTip = false;

Sentry.init({
  dsn: "https://5ab77896716c478584e1a0ec03da6e07@sentry.io/1435012",
  integrations: [
    new Integrations.Vue({
      Vue,
      attachProps: true
    })
  ],
  ignoreErrors: [
    // Random plugins/extensions
    "top.GLOBALS",
    // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
    "originalCreateNotification",
    "canvas.contentDocument",
    "MyApp_RemoveAllHighlights",
    "http://tt.epicplay.com",
    "Can't find variable: ZiteReader",
    "jigsaw is not defined",
    "ComboSearch is not defined",
    "http://loading.retry.widdit.com/",
    "atomicFindClose",
    // Facebook borked
    "fb_xd_fragment",
    // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
    // reduce this. (thanks @acdha)
    // See http://stackoverflow.com/questions/4113268
    "bmi_SafeAddOnload",
    "EBCallBackMessageReceived",
    // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
    "conduitPage",
    "ResizeObserver loop limit exceeded",
    "Network Error",
    "NetworkError",
    "Network request failed",
    "Failed to fetch",
    "Maximum call stack size exceeded",
    "NavigationDuplicated",
    "createRouterError",
    "Object.postMessage(widget)",
    "Loading chunk 1 failed.",
    "Loading chunk 1 failed",
    "Loading chunk 3 failed.",
    "Loading chunk 3 failed",
    "InternalError",
    "RangeError",
    "Illegal invocation",
    "ResizeObserver loop completed with undelivered notifications",
    "Non-Error exception captured"
  ],
  denyUrls: [
    // Facebook flakiness
    /graph\.facebook\.com/i,
    // Facebook blocked
    /connect\.facebook\.net\/en_US\/all\.js/i,
    // Woopra flakiness
    /eatdifferent\.com\.woopra-ns\.com/i,
    /static\.woopra\.com\/js\/woopra\.js/i,
    // Chrome extensions
    /extensions\//i,
    /^chrome:\/\//i,
    // Other plugins
    /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
    /webappstoolbarba\.texthelp\.com\//i,
    /metrics\.itunes\.apple\.com\.edgesuite\.net\//i
  ],

  environment: process.env.NODE_ENV
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js